import styled from 'styled-components';
import { width, space, height, color, border, typography } from 'styled-system';
//////////////////////////////////////////////////

const SimpleInput = styled.input`
  ${space}
  ${width}
  ${color}
  ${height}
  ${border}
  ${typography}

  outline: none;
  z-index: unset;

  background: ${({ background }) => background};
`;

SimpleInput.defaultProps = {
  height: 30,
  width: 100,
  p: '0 16px',
  borderRadius: 2,
};

export {
  SimpleInput,
};
